// extracted by mini-css-extract-plugin
export default {"activeSidebar":"C-z","pageLayout":"D-z","mainContent":"E-z","columnLayout":"F-z","columnLayoutFill":"G-z","columnLayoutLast":"H-z"};